import React from "react";
import DashboardContent from "../components/Dashboard/Dashboard";
import MainLayout from "../components/MainLayout/MainLayout";

function Dashboard() {
  return (
    <MainLayout>
      <DashboardContent />
    </MainLayout>
  );
}

export default Dashboard;